import instance from "../../utils/axios";

const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v ?? ""));
  return formData;
};

/* SAVE */
export const saveResourceVideo = async (payload) => {
  const res = await instance.post(
    "/churches/resources/resourcevideos/save",
    toFormData(payload)
  );
  return res.data;
};

/* UPDATE */
export const updateResourceVideo = async (payload) => {
  const res = await instance.post(
    "/churches/resources/resourcevideos/update",
    toFormData(payload)
  );
  return res.data;
};

/* DELETE */
export const deleteResourceVideo = async (payload) => {
  const res = await instance.post(
    "/churches/resources/resourcevideos/delete",
    toFormData(payload)
  );
  return res.data;
};

/* READ */
export const readResourceVideos = async (payload) => {
  const res = await instance.post(
    "/churches/resources/resourcevideos/read",
    toFormData(payload)
  );
  return res.data;
};
